import { render, staticRenderFns } from "./msgCard.vue?vue&type=template&id=3a7b5cc9&scoped=true&"
import script from "./msgCard.vue?vue&type=script&lang=js&"
export * from "./msgCard.vue?vue&type=script&lang=js&"
import style0 from "./msgCard.vue?vue&type=style&index=0&id=3a7b5cc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b5cc9",
  null
  
)

export default component.exports